{
  "name": "unity.ui.framework",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "lint:MarketMessenger": "npx cross-env LINT_SUBMODULE=MarketMessenger ng lint",
    "lint:MessageVault": "npx cross-env LINT_SUBMODULE=MessageVault ng lint",
    "lint:Reporting": "npx cross-env LINT_SUBMODULE=Reporting ng lint",
    "lint:Settings": "npx cross-env LINT_SUBMODULE=Settings ng lint",
    "lint:submodules": "npm run lint:MarketMessenger && npm run lint:MessageVault && npm run lint:Reporting && npm run lint:Settings",
    "prepare": "husky",
    "storybook": "ng run Unity.UI.Framework:storybook",
    "build-storybook": "ng run Unity.UI.Framework:build-storybook"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.0",
    "@angular/cdk": "^20.0.0",
    "@angular/common": "^20.0.0",
    "@angular/compiler": "^20.0.0",
    "@angular/core": "^20.0.0",
    "@angular/forms": "^20.0.0",
    "@angular/material": "^20.0.0",
    "@angular/material-moment-adapter": "^20.0.0",
    "@angular/platform-browser": "^20.0.0",
    "@angular/platform-browser-dynamic": "^20.0.0",
    "@angular/router": "^20.0.0",
    "@angular/service-worker": "^20.0.0",
    "@azure/msal-angular": "^4.0.12",
    "@azure/msal-browser": "^4.13.2",
    "@datorama/akita": "^8.0.1",
    "@jsonforms/angular": "^3.7.0",
    "@jsonforms/angular-material": "^3.7.0",
    "@jsonforms/core": "^3.7.0",
    "@ng-bootstrap/ng-bootstrap": "^19.0.0",
    "@ngneat/elf": "^2.5.1",
    "@ngneat/until-destroy": "^10.0.0",
    "@popperjs/core": "^2.11.8",
    "ag-charts-community": "^10.0.0",
    "bootstrap": "^5.3.6",
    "crypto-js": "^4.2.0",
    "dayjs": "^1.11.13",
    "flatted": "^3.3.3",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "ng-dynamic-component": "^10.8.2",
    "ngx-logger": "^5.0.12",
    "pretty-print-json": "^3.0.6",
    "rxjs": "~7.8.0",
    "short-uuid": "^5.2.0",
    "tslib": "2.4.1",
    "uuid": "^11.1.0",
    "zone.js": "~0.15.0"
  },
  "overrides": {
    "@storybook/angular": {
      "@angular-devkit/build-angular": "$@angular-devkit/build-angular"
    }
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.0.0",
    "@angular/cli": "^20.0.0",
    "@angular/compiler-cli": "^20.0.0",
    "@storybook/addon-docs": "^10.2.8",
    "@storybook/angular": "^10.2.8",
    "@types/crypto-js": "^4.2.0",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.17",
    "@types/uuid": "^10.0.0",
    "angular-eslint": "^20.0.0",
    "eslint": "^9.26.0",
    "eslint-plugin-storybook": "10.2.8",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "storybook": "^10.2.8",
    "typescript": "~5.8.0",
    "typescript-eslint": "8.32.0",
    "cross-env": "^7.0.3",
    "husky": "^9.1.7",
    "lint-staged": "^15.4.3"
  },
  "lint-staged": {
    "*.{ts,html}": "eslint --max-warnings 0 --no-warn-ignored"
  }
}